import { QUESTIONS, QUESTIONS_PER_PAGE, TOTAL_PAGES } from "./questions.js";
import { FACTORS, FACTOR_MAP, NORMS } from "./factors.js";
import { scoreBigFive } from "./scoring.js";
import { NINEBOX_CELLS } from "../../constants/competencies.js";

function buildAIPrompt(a,type){
  const s=a.scores||{},cell=NINEBOX_CELLS.find(c=>c.x===a.perfBox&&c.y===a.potBox);
  const lines=FACTORS.map(f=>{const v=s[f.id]||"—";return`  • ${f.name}(${f.id}):${v}/10`;}).join("\n");
  return`Expert I/O psychologist interpreting Big Five IPIP-120.\n${type==="hiring"?"HIRING":"DEVELOPMENT"} REPORT\nCandidate:${a.name}|${a.role}|${a.demo?.country||""}\n9-Box:${cell?.label||"—"}\nFactors:\n${lines}`;
}

export default{
  id:"bigfive",name:"Big Five Personality Inventory",shortName:"Big Five",
  version:"IPIP-120",publisher:"International Personality Item Pool (Public Domain)",
  description:"120-item inventory measuring the five fundamental dimensions of personality: Neuroticism, Extraversion, Openness, Agreeableness and Conscientiousness.",
  icon:"🌊",color:"#7c3aed",bg:"#f5f3ff",
  totalQuestions:120,timeEstimate:"15–20 min",scaleType:"likert-5",
  pagesOf:QUESTIONS_PER_PAGE,totalPages:TOTAL_PAGES,
  questions:QUESTIONS,scales:FACTORS,scaleMap:FACTOR_MAP,
  domains:[
    {id:"emotional",label:"Emotional",icon:"🌊",color:"#7c3aed",bg:"#f5f3ff"},
    {id:"social",label:"Social",icon:"⚡",color:"#d97706",bg:"#fef3c7"},
    {id:"intellectual",label:"Intellectual",icon:"🔭",color:"#0891b2",bg:"#cffafe"},
    {id:"interpersonal",label:"Interpersonal",icon:"🤝",color:"#16a34a",bg:"#dcfce7"},
    {id:"motivational",label:"Motivational",icon:"📋",color:"#1d4ed8",bg:"#dbeafe"},
  ],
  norms:NORMS,competencies:null,
  nineboxAxes:{x:{label:"Delivery Effectiveness",description:"Conscientiousness + Emotional Stability",scaleIds:["C","N"]},y:{label:"Growth Agility",description:"Openness + Extraversion",scaleIds:["O","E"]}},
  nineboxCells:NINEBOX_CELLS,
  score:scoreBigFive,buildAIPrompt,
  answerFormat:{type:"likert-5",options:[{value:1,label:"Very Inaccurate",short:"1"},{value:2,label:"Moderately Inaccurate",short:"2"},{value:3,label:"Neither",short:"3"},{value:4,label:"Moderately Accurate",short:"4"},{value:5,label:"Very Accurate",short:"5"}]},
};
